<app-mu-section-title title="context.massive.newRouting.breadcrumb.title" subTitle="context.massive.newRouting.breadcrumb.subtitle"></app-mu-section-title>
<app-new-routing-search-form-component 
    [flagList]="flagList"
    [showCreateCediFlag]="massiveNewRoutingSearchFlags.CREATE_CEDI_MODAL"
    [continueToDeliveries]="massiveNewRoutingSearchFlags.CONTINUE_TO_DELIVERIES"
    [formData]="formData" 
    [coutriesListInput]="coutriesListInput" 
    [citiesListInput]="citiesListInput" 
    [companiesListInput]="companiesListInput" 
    [cediPointsListInput]="cediPointsListInput"	
    >
</app-new-routing-search-form-component>

<p-dialog header="Nuevo punto" [(visible)]="showModalCedi" [style]="{ width: '50vw' }">
    <app-create-cedi-point
      [cities]="cities"
      [country]="selectedCountry"
      [company]="selectedCompany"
      [filtercities]="filteredCities"
      (closecedimodal)="handleModalCedi()"
      (showtoast)="showSuccess()"
      (filteredcities)="filterCities($event)"
    ></app-create-cedi-point>
</p-dialog>